/**
 * Created by Vinicius
 */

import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import { NbDialogService } from '@nebular/theme';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import {
  AssessmentData,
  AssessmentFilter,
  AssessmentView,
  ENERGY_LEVEL,
  MEAL_PLAN_COMPILANCE,
  SLEEP_QUALITY,
  STRESS_LEVEL,
} from 'app/@core/interfaces/common/CalorieFriend/assessment';
import { EditAssessmentComponent } from '../Assessments/edit-assessment.component';
import { UsersService } from './../../../../@core/backend/common/services/users.service';
import { UserStore } from 'app/@core/stores/user.store';

@Component({
  selector: 'app-patient-assessment-list',
  templateUrl: './assessment-list.component.html',
  styleUrls: ['./assessment-list.component.scss'],
})
export class PatientAssessmentListComponent implements OnDestroy {
  @Input() set patientId(value: number) {
    if (!value) return;
    this.paging.patientId = value;

    // default sort and load data initially
    this.sortor.sort({
      id: this.paging.sortBy,
      start: this.paging.orderBy,
    } as MatSortable);
  }
  @Input() set patientGuid(value: string) {
    if (!value?.length) return;
    this.paging.patientGuid = value;

    // default sort and load data initially
    this.sortor.sort({
      id: this.paging.sortBy,
      start: this.paging.orderBy,
    } as MatSortable);
  }
  @Input() patientIsPreferredUnitImperial: boolean = false;

  @Output() edited: EventEmitter<void> = new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: true }) sortor?: MatSort;

  readonly displayedColumns = [
    'image',
    'endDateString',
    'mealPlanCompliance',
    'energyLevel',
    'stressLevel',
    'sleepQuality',
    'actions',
  ];
  totalCount: number = 0;
  dataList: AssessmentView[] = [];
  MEAL_PLAN_COMPILANCE = MEAL_PLAN_COMPILANCE;
  ENERGY_LEVEL = ENERGY_LEVEL;
  STRESS_LEVEL = STRESS_LEVEL;
  SLEEP_QUALITY = SLEEP_QUALITY;

  private unsubscribe$ = new Subject<void>();
  private paging: AssessmentFilter = {
    sortBy: 'startDateString',
    orderBy: 'desc',
  };

  constructor(
    private assessmentService: AssessmentData,
    private dialogService: NbDialogService,
    private userStore: UserStore,
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onSortChanged(sort: Sort): void {
    this.paging.sortBy = sort.active;
    this.paging.orderBy = sort.direction;
    this.loadDataList(true);
  }

  loadDataList(pagination: boolean = false): void {
    if (!this.paging.patientId && !this.paging.patientGuid) return;

    if (!pagination && this.paginator) this.paginator.pageIndex = 0;
    this.paging.pageNumber = pagination
      ? this.paginator?.pageIndex + 1 ?? 1
      : 1;
    this.paging.pageSize = this.paginator?.pageSize ?? 10;

    this.assessmentService
      .list(this.paging)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.totalCount = res.totalCount;
        this.dataList = res.items;
      });
  }

  weight(weight: number): string {
    return this.patientIsPreferredUnitImperial
      ? Math.round((weight / 0.453592) * 10) / 10 + ' lbs'
      : weight + ' kg';
  }

  onEdit(assessmentGuid: string): void {
    this.dialogService
      .open(EditAssessmentComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          AssessmentGuid: assessmentGuid,
          PatientGuid: this.paging.patientGuid,
          UserId: this.userStore.getUser()?.id
        },
      })
      .onClose.subscribe(() => {
        this.loadDataList(true);
        this.edited.emit();
      });
  }
}
